import React from "react";
import moment from "moment";
import { FaStar, FaRegStar, FaStore } from "react-icons/fa";
import "./Reviews.css";

export default function ReviewItem({ review }) {
    const authorName = review.authorName || "Anonymous";
    const authorImage = review.customerImage ? `data:image/jpeg;base64,${review.customerImage}` : null;
    const timeDesc = review.createdAt ? moment(review.createdAt).fromNow() : "";
    const reviewText = review.review || review.text || "";

    const renderStars = (rating) => {
        return (
            <div className="review-stars-row">
                {[1, 2, 3, 4, 5].map((i) => (
                    <span key={i}>
                        {i <= rating ? <FaStar className="star-filled" /> : <FaRegStar className="star-empty" />}
                    </span>
                ))}
            </div>
        );
    };

    return (
        <div className="premium-review-item">
            <div className="review-author-row">
                {authorImage ? (
                    <img src={authorImage} className="review-author-img" alt={authorName} />
                ) : (
                    <div className="review-author-placeholder">
                        {authorName.charAt(0).toUpperCase()}
                    </div>
                )}
                <div className="review-meta">
                    <h5 className="review-author-name">{authorName}</h5>
                    <span className="review-time">{timeDesc}</span>
                </div>
            </div>

            {renderStars(review.rating)}

            <p className="review-text-content">{reviewText}</p>

            {review.ownerReplied && review.ownerReply && (
                <div className="owner-reply-box">
                    <div className="owner-reply-header">
                        <FaStore className="me-2 text-primary" />
                        <span className="owner-label">Business Response</span>
                        {review.ownerReplyDate && (
                            <span className="reply-date">{moment(review.ownerReplyDate).format("DD MMM, YYYY")}</span>
                        )}
                    </div>
                    <p className="reply-text">{review.ownerReply}</p>
                </div>
            )}
        </div>
    );
}
